import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _isMostPopularListsHidden } from "@discovery/common-dplus/lib/state";
import { Typography, HeaderVariants, Tags, } from "../../components/atoms/typography";
import Strings from "../../utils/hardcoded.json";
import * as styles from "./styles.css";
import { _ShowAndVideoCollection } from "../optics";
const SecondaryCardCompact = React.lazy(() => import("../../components/molecules/cards/card/secondary-card-compact"));
const getProps = (data) => {
    const mostPopular = Fold.toArray(_ShowAndVideoCollection, data);
    return {
        mostPopular,
    };
};
const MostPopularLists = ({ mostPopular }) => {
    const [isMostPopularListsHidden] = useGlobalState(_isMostPopularListsHidden);
    return (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) }, isMostPopularListsHidden ? (React.createElement(React.Fragment, null)) : (React.createElement("div", { className: styles.mostPopularWrapper },
        React.createElement(Typography, { classNameM: M.of(styles.title), variant: HeaderVariants.headingSix, tag: Tags.h6 },
            React.createElement(React.Fragment, null, Strings.MOST_POPULAR)),
        mostPopular.map((item, index) => (React.createElement(SecondaryCardCompact, { cardData: item, title: Strings.MOST_POPULAR, category: item.category, key: index, debouncedSearchTerm: "", searchResultsLength: 0, isSearchPage: true })))))));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, MostPopularLists);

